import Zone from "@insite/client-framework/Components/Zone";
import translate from "@insite/client-framework/Translate";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Modals from "@insite/content-library/Components/Modals";
import Button from "@insite/mobius/Button";
import Page from "@insite/mobius/Page";
import PunchoutModal from "@TKCCP/Components/PunchoutModal";
import loadPunchouts from "@TKCCP/Store/Data/PunchoutSecretService/Handlers/LoadPunchoutSecretHandler";
import {
    getPunchoutDataView,
    PunchoutDataViewContext,
} from "@TKCCP/Store/Data/PunchoutSecretService/PunchoutSecretServiceSelector";
import updateLoadParameter from "@TKCCP/Store/Pages/PunchoutSecret/Handlers/UpdateLoadParameter";
import ApplicationStateTKCCP from "@TKCCP/Store/TKCCPState";
import React, { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationStateTKCCP) => ({
    punchoutDataView: getPunchoutDataView(state, state.pagePunchoutSecret.getPunchoutParameter),
    getPunchoutParameter: state.pagePunchoutSecret.getPunchoutParameter,
});

const mapDispatchToProps = {
    loadPunchouts,
    updateLoadParameter,
};

type Props = PageProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const PunchoutSecretPage = ({ id, loadPunchouts, punchoutDataView, getPunchoutParameter }: Props) => {
    useEffect(() => {
        // if this is undefined it means someone changed the filters and we haven't loaded the new collection yet
        if (!punchoutDataView.value && !punchoutDataView.isLoading) {
            loadPunchouts(getPunchoutParameter);
        }
    });

    const value = punchoutDataView.value;

    return (
        <Page>
            <PunchoutDataViewContext.Provider value={punchoutDataView}>
                <PunchoutModal />
                <Zone contentId={id} zoneName="Content" />
                <Modals />
            </PunchoutDataViewContext.Provider>
        </Page>
    );
};

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(PunchoutSecretPage),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        fieldDefinitions: [],
        pageType: "System",
    },
};

export default pageModule;
export const PunchoutSecretPageContext = "PunchoutSecretPage";
